export const SPACING = {
  xxs: "4px",
  xs: "8px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "48px",
  xxl: "64px",
  xxxl: "128px",
};
